import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";
import { Button, CircularProgress, Stack, Tooltip } from "@mui/material";

import { ADD_PARTNER_COPY } from "./constants";

interface Props {
  onSubmit: VoidFunction;
  inviteSent: boolean;
  hasFailed: boolean;
  isLoading: boolean;
  buttonVariant?: "contained" | "outlined";
}

export function AddCarrierToNetowrkButton(props: Props) {
  const {
    onSubmit,
    inviteSent,
    hasFailed,
    isLoading,
    buttonVariant = "outlined",
  } = props;

  if (isLoading) {
    return (
      <Stack>
        <CircularProgress size={20} />
      </Stack>
    );
  }

  if (inviteSent) {
    return (
      <Stack>
        {/* A disabled button emits no pointer events, so the tooltip needs a
        wrapper element to hang off. */}
        <Tooltip title={ADD_PARTNER_COPY.inviteSent.tooltip}>
          <span>
            <Button variant="outlined" disabled fullWidth>
              <CheckIcon />
              {ADD_PARTNER_COPY.inviteSent.label}
            </Button>
          </span>
        </Tooltip>
      </Stack>
    );
  }

  const copy = hasFailed
    ? ADD_PARTNER_COPY.failed
    : ADD_PARTNER_COPY.actionable;

  return (
    <Stack>
      <Tooltip title={copy.tooltip}>
        <Button
          variant={buttonVariant}
          onClick={onSubmit}
          color={hasFailed ? "error" : "primary"}
        >
          <AddIcon />
          {copy.label}
        </Button>
      </Tooltip>
    </Stack>
  );
}
